module.exports = __webpack_public_path__ + "img/contexity-logo-white.2d0cbc1b.png";